import React from 'react';
import { connect } from 'react-redux';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import SideMenu from './SideMenu';

import './Dashboard.css';
import { history } from '../helpers';
import Activity from './activity/Activity';
import Timer from './timer/Timer';
import History from './history/History';
import Projects from './projects/Projects';
import Settings from './settings/Settings';

const Dashboard = () => (
  <div className="dashboard-root">
    <SideMenu />
    <div className="dashboard-content">
      <Router history={history}>
        <Switch>
          <Route exact path="/activity" component={Activity} />
          <Route exact path="/timer" component={Timer} />
          <Route exact path="/history" component={History} />
          <Route exact path="/projects" component={Projects} />
          <Route exact path="/settings" component={Settings} />
          <Route render={() => <Redirect to="/activity" />} />
        </Switch>
      </Router>
    </div>
  </div>
);

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js